// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageTileList_container__1MnMY"};